import { useState } from 'react';

interface FaqItem {
  question: string;
  answer: string;
}

interface FaqAccordionProps {
  items: FaqItem[];
}

export function FaqAccordion({ items }: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <div>
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        const answerId = `faq-answer-${index}`;

        return (
          <div
            key={index}
            style={{
              borderBottom: '1px solid #e5e7eb',
            }}
          >
            <button
              onClick={() => toggle(index)}
              aria-expanded={isOpen}
              aria-controls={answerId}
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                cursor: 'pointer',
                backgroundColor: 'transparent',
                border: 'none',
                padding: 'var(--spacing-md) 0',
                fontFamily: 'var(--font-body)',
                textAlign: 'left',
              }}
            >
              <span
                style={{
                  fontSize: '18px',
                  fontWeight: 600,
                  color: '#111827',
                  lineHeight: 1.2,
                }}
              >
                {item.question}
              </span>
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                style={{
                  flexShrink: 0,
                  marginLeft: 'var(--spacing-md)',
                  transition: 'transform 200ms ease',
                  transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                }}
              >
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </button>
            <div
              id={answerId}
              role="region"
              aria-labelledby={`faq-question-${index}`}
              style={{
                overflow: 'hidden',
                maxHeight: isOpen ? '500px' : '0',
                transition: 'max-height 200ms ease',
              }}
            >
              <p
                style={{
                  fontSize: '16px',
                  fontWeight: 400,
                  color: '#6b7280',
                  paddingTop: 'var(--spacing-md)',
                  paddingBottom: 'var(--spacing-md)',
                  lineHeight: 1.5,
                }}
              >
                {item.answer}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
